import React from "react";
import { Link } from "react-router-dom";
export default function BusinessConsulting() {
    return (
        <>
            {/* Hero Banner */}
            <section className="py-5 bg-white-gradient text-center position-relative">
                <div className="container py-4">
                    <h1 className="display-5 fw-bold mb-2 consulting-gradient-text">
                        Intelligent Business Consulting
                    </h1>
                    <p
                        className="lead text-secondary mb-4 mx-auto"
                        style={{ maxWidth: 700 }}
                    >
                        Empowering organizations to thrive in disruptive times.
                        <br />
                        Strategic advice, technology transformation, and operational excellence—delivered by industry experts who care about results.
                    </p>

                    {/* Newly added introductory paragraph */}
                    <p className="mb-4 text-body" style={{ maxWidth: 800, margin: "0 auto" }}>
                        As customers transition from legacy voice support to advanced digital engagement channels,
                        industries are evolving at an extraordinary pace.
                        At Nexen, we leverage technology that learns from human intelligence,
                        creating digital solutions for over a decade to empower businesses to stay ahead of the competition.
                        Focus on your core strengths while we manage the infrastructure.
                    </p>

                    <a
                        href="#solutions"
                        className="btn btn-lg btn-primary px-5 py-2 fw-bold mt-2 shadow"
                    >
                        Our Solutions
                    </a>
                </div>
                {/* Decorative flair */}
                {/* <div
                    className="position-absolute top-0 start-0 translate-middle opacity-15"
                    style={{
                        width: 120,
                        height: 120,
                        background: "linear-gradient(135deg, #6b46c1, #d53f8c 85%)",
                        borderRadius: "50%",
                    }}
                ></div> */}
            </section>

            {/* Consulting Services Section */}
            <section className="py-5 bg-light">
                <div className="container" id="consulting-services">
                    {/* <h2 className="fw-bold consulting-gradient-text text-center mb-5">
            Consulting Services
          </h2> */}

                    <p className="mb-4 text-body lead text-secondary mb-4 mx-auto" style={{ maxWidth: 900, margin: "0 auto" }}>
                        Nexen Consulting specializes in defining, optimizing, and aligning our clients' IT strategies.
                        Our services include:
                    </p>

                    <ul className="lead text-secondary mb-4 mx-auto"style={{ maxWidth: 700, margin: "0 auto 2rem auto", paddingLeft: "1.2rem" }}>
                        <li>Enterprise Architecture Evaluation</li>
                        <li>Application Reviews</li>
                        <li>Technology Applications</li>
                        <li>Business Process Evaluation</li>
                        <li>Business Process Re-engineering</li>
                    </ul>

                    <p className="mb-4 text-body lead text-secondary mb-4 mx-auto" style={{ maxWidth: 900, margin: "0 auto" }}>
                        To ensure technology effectively supports business needs and that IT investments generate the desired value,
                        it is crucial to establish an Information System Architecture (ISA) and assess its alignment with the business model and existing technologies.
                        Nexen Consulting has the expertise and experience to deliver comprehensive system enhancements.
                    </p>
                </div>
            </section>

            {/* Solutions Cards */}
            <section id="solutions" className="py-5 bg-light">
                <div className="container">
                    <h2 className="fw-bold consulting-gradient-text text-center mb-5">What We Do</h2>
                    <div className="row g-4 justify-content-center">
                        <div className="col-md-4">
                            <div className="card border-0 shadow h-100 p-4 text-center animate-fadeInUp">
                                <span
                                    className="rounded-circle bg-primary bg-opacity-10 d-inline-flex align-items-center justify-content-center mb-3 icon-64"
                                >
                                    <i className="bi bi-diagram-3 fs-2 text-primary"></i>
                                </span>
                                <h5 className="fw-semibold consulting-gradient-text">
                                    Strategy & Transformation
                                </h5>
                                <p className="text-secondary small">
                                    Business model innovation, digital strategy, and long-range planning for lasting competitive edge.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card border-0 shadow h-100 p-4 text-center animate-fadeInUp delay-1">
                                <span
                                    className="rounded-circle bg-success bg-opacity-10 d-inline-flex align-items-center justify-content-center mb-3 icon-64"
                                >
                                    <i className="bi bi-cpu-fill fs-2 text-success"></i>
                                </span>
                                <h5 className="fw-semibold consulting-gradient-text">
                                    Tech & Process Excellence
                                </h5>
                                <p className="text-secondary small">
                                    Digital transformation, workflow automation, and process reengineering to boost agility and efficiency.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card border-0 shadow h-100 p-4 text-center animate-fadeInUp delay-2">
                                <span
                                    className="rounded-circle bg-warning bg-opacity-10 d-inline-flex align-items-center justify-content-center mb-3 icon-64"
                                >
                                    <i className="bi bi-bar-chart-line-fill fs-2 text-warning"></i>
                                </span>
                                <h5 className="fw-semibold consulting-gradient-text">
                                    Data, Analytics & Change
                                </h5>
                                <p className="text-secondary small">
                                    Metrics dashboards, analytics enablement, lean management and sustainable culture change for growth.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* How We Work - Process Timeline */}
            <section className="py-5 bg-white">
                <div className="container">
                    <h3 className="fw-bold text-primary text-center mb-4">Our Approach</h3>
                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <ol className="process-timeline list-unstyled d-flex flex-column flex-md-row justify-content-between align-items-center gap-4">
                                <li>
                                    <div className="timeline-step mb-2">
                                        <span className="badge bg-primary fs-5">1</span>
                                    </div>
                                    <div>
                                        <strong className="consulting-gradient-text">Discovery</strong>
                                        <div className="small text-secondary">Assess needs, goals, and current landscape</div>
                                    </div>
                                </li>
                                <li>
                                    <div className="timeline-step mb-2">
                                        <span className="badge bg-success fs-5">2</span>
                                    </div>
                                    <div>
                                        <strong className="consulting-gradient-text">Strategy</strong>
                                        <div className="small text-secondary">Develop a tailored roadmap with clear KPIs</div>
                                    </div>
                                </li>
                                <li>
                                    <div className="timeline-step mb-2">
                                        <span className="badge bg-warning fs-5">3</span>
                                    </div>
                                    <div>
                                        <strong className="consulting-gradient-text">Implementation</strong>
                                        <div className="small text-secondary">Execute transformation with minimal disruption</div>
                                    </div>
                                </li>
                                <li>
                                    <div className="timeline-step mb-2">
                                        <span className="badge bg-primary fs-5">4</span>
                                    </div>
                                    <div>
                                        <strong className="consulting-gradient-text">Continuous Value</strong>
                                        <div className="small text-secondary">Track, optimize, and empower your people</div>
                                    </div>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            {/* Call to Action */}
            {/* <section className="py-5 bg-primary bg-gradient text-white text-center">
                <div className="container">
                    <h3 className="fw-bold mb-3">Unlock Your Organization's True Potential</h3>
                    <p className="mb-4">
                        Request a corporate consultation today and let our experts guide you into the future.
                    </p>
                    <Link to="/contact" className="btn btn-lg btn-light px-5 fw-bold shadow">
                        Contact Us
                    </Link>
                </div>
            </section> */}

            <section className="py-12 bg-gradient-to-r from-purple-700 to-pink-600 text-white text-center position-relative overflow-hidden">
                <div className="container max-w-3xl relative z-10">
                    <h2 className="display-4 fw-bold mb-4" style={{ color: "#15d6ddff" }}>
                        Unlock Your Organization's True Potential
                    </h2>
                    <p className="lead mb-5 opacity-85">
                        Request a corporate consultation today and let our experts guide you into the future.
                    </p>
                </div>

                {/* Decorative blurred circles */}
                <div className="d-flex justify-content-center">
                    <Link
                        to="/contact"
                        className="btn btn-lg rounded-pill fw-bold text-white px-5 py-3"
                        style={{
                            background: 'linear-gradient(90deg, #6B46C1, #D53F8C)',
                            boxShadow: '0 4px 15px rgba(213, 63, 140, 0.6)',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 8px 30px rgba(213, 63, 140, 0.9)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(213, 63, 140, 0.6)';
                        }}
                    >
                        Get in Touch
                    </Link>
                </div>
            </section>


            {/* Custom styles */}
            <style>{`
        .consulting-gradient-text {
          background: linear-gradient(90deg,#6b46c1,#d53f8c 80%);
          color: transparent;
          -webkit-background-clip: text;
          background-clip: text;
        }
        .bg-white-gradient {
          background: linear-gradient(135deg, #f8f8ff 60%, #ffe2fa 100%);
        }
        .process-timeline {
          position: relative;
          margin: 0;
          padding: 0;
        }
        .process-timeline li {
          position: relative;
          flex: 1 1 0%;
          text-align: center;
        }
        .process-timeline .timeline-step {
          margin-bottom: 6px;
        }
        .process-timeline::before {
          content: "";
          position: absolute;
          top: 25px;
          left: 8%; right: 8%;
          height: 3px;
          background: linear-gradient(90deg, #6b46c1 0%, #d53f8c 100%);
          z-index: 0;
        }
        .process-timeline li {
          z-index: 1;
        }
        @media (max-width: 767.98px) {
          .process-timeline::before { display: none; }
          .process-timeline li { margin-bottom: 1.5rem; }
        }
        .animate-fadeInUp { animation: fadeInUp 0.7s ease both; }
        .delay-1 { animation-delay: 0.12s; }
        .delay-2 { animation-delay: 0.24s; }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px);}
          to { opacity: 1; transform: translateY(0);}
        }
      `}</style>
        </>
    );
}
